export default {
  flat: 'flat',
  container: 'container',
  interactive: 'interactive',
  float: 'float',
  hover: 'hover',
};
